import { Helmet } from "react-helmet-async";

/**
 * LocalSEOSchema - Injects JSON-LD structured data for local SEO
 * Supports: LocalBusiness, Service, FAQ, BreadcrumbList
 */
const LocalSEOSchema = ({ 
  schema, 
  pageTitle, 
  metaDescription, 
  canonicalUrl,
  city,
  state,
  service,
  imageUrl
}) => {
  const schemaScript = schema ? JSON.stringify(schema) : null;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{pageTitle}</title>
      <meta name="description" content={metaDescription} />
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={metaDescription} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      {imageUrl && <meta property="og:image" content={imageUrl} />}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={metaDescription} />
      {imageUrl && <meta name="twitter:image" content={imageUrl} />}
      
      {/* Geo Tags for Local SEO */}
      {city && state && (
        <>
          <meta name="geo.region" content={`US-${state}`} />
          <meta name="geo.placename" content={city} />
        </>
      )}
      
      {/* JSON-LD Structured Data */}
      {schemaScript && (
        <script type="application/ld+json">
          {schemaScript}
        </script>
      )}
    </Helmet>
  );
};

export default LocalSEOSchema;
